import React from 'react';
import { Resources } from 'lib/templates/Feature.BOKF.model';
import WidgetWrapper from 'helpers/WidgetWrapper/WidgetWrapper';
import { SearchWithFilterWidget } from 'widgets/SearchWithFilterWidget/SearchWithFilterWidget';
import { getBreakpoint, useCurrentScreenType } from 'lib/utils/get-screen-type';

const SearchWithFilter = (
  props: Required<Resources.Configuration.SearchFilterConfiguration>
): JSX.Element => {
  const { currentScreenWidth, isScreenTypeDetected } = useCurrentScreenType();
  // Wait until the screen type is detected
  if (!isScreenTypeDetected || !props.fields) return <></>;

  return (
    <WidgetWrapper>
      <SearchWithFilterWidget
        rfkId="resource_search"
        {...props}
        InitialCount={
          (currentScreenWidth <= getBreakpoint('desktop')
            ? props?.fields?.InitialCountMobile?.value
            : props?.fields?.InitialCountDesktop?.value) as number
        }
      />
    </WidgetWrapper>
  );
};

export default SearchWithFilter;
